import React, { useState, useRef, useEffect } from 'react';
import commonUtil from '../../../../../../utils/commonUtil';

export default function MobileTooltip({ lables }) {
  const [open, setOpen] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    function handleOutsideClick(e) {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener('touchstart', handleOutsideClick);
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('touchstart', handleOutsideClick);
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [open]);

  return (
    <div ref={tooltipRef} className='fav-tooltip-div'>
      <img
        src={commonUtil.getAssetURL() + '/images/help.svg'}
        alt='icon_help'
        className='icon_help'
        onClick={() => setOpen((prev) => !prev)}
      />

      {open && (
        <div
          id='helpPopup'
          className='popover bottom helpIconCssEmail fav-tooltip'
        >
          <div className='arrow' />
          <div className='popover-content'>
            <p>
              {commonUtil.getLabel(
                lables.EventAdminPage,
                'adminpage.regalosregistrados.item.favorite.gift.tooltip.text',
              )}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
